export default __webpack_public_path__ + "static/media/crvUSDBTCETH3.99df341a.svg";